export default function VitrineHeader({
  selectedBrand,
  brandColors,
  data,
  mobile,
}) {
  const isKarstenLayout = selectedBrand === "karsten";
  const isTrussardiLayout = selectedBrand === "trussardi";
  const isMixLayout = selectedBrand === "mix";

  return (
    <>
      <header
        style={{
          paddingBottom: "24px",
          borderBottom: `1px solid ${brandColors.border}`,
          marginTop: mobile ? "38px" : "0",
          marginBottom: "24px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: isTrussardiLayout ? "column" : "row",
            gap: isMixLayout ? "16px" : "0",
            height: "48px",
          }}
        >
          {(isMixLayout || isKarstenLayout) && (
            <>
              <img
                src="https://iokarsten.vtexassets.com/assets/vtex.file-manager-graphql/images/cb6590ab-ea58-4063-a4b1-673bdb166642___464bf66f2ca33012cc9abedc51050767.svg"
                alt="Logo Karsten"
                style={{ height: "32px" }}
              />
            </>
          )}
          {(isMixLayout || isTrussardiLayout) && (
            <>
              <img
                src="https://iotrussardi.vtexassets.com/assets/vtex.file-manager-graphql/images/0709f316-5675-4f95-abe1-f104e2e8b8ea___9a060d9f3446d5d93cea6df2a681b266.svg"
                alt="Logo Trussardi"
                style={{ height: "32px" }}
              />
              {!isMixLayout && (
                <p
                  className="font-title"
                  style={{
                    fontSize: "12px",
                    letterSpacing: "0.1em",
                    marginTop: "8px",
                    fontFamily: "'Montserrat', sans-serif",
                    fontWeight: 500,
                  }}
                >
                  ESTADO DA ARTE NA ROTINA
                </p>
              )}
            </>
          )}
        </div>
      </header>

      <div
        style={{
          backgroundColor: brandColors.surface,
          padding: "16px",
          borderRadius: "8px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          marginBottom: "32px",
          textAlign: "center",
        }}
      >
        <p
          style={{
            fontSize: "18px",
            marginBottom: "4px",
            fontFamily: "inherit",
            fontWeight: 500,
          }}
        >
          Olá! Seja bem-vindo(a) à nossa Vitrine Virtual {" "}
          {data?.store ? `da ${data?.store}` : ""}.
        </p>
        <p
          style={{
            fontSize: "14px",
            color: brandColors.textMuted,
            marginTop: "4px",
          }}
        >
          {isMixLayout
            ? "Uma seleção especial de produtos Karsten e Trussardi para você, por "
            : "Uma seleção de produtos exclusivos para você, por "}
          <span style={{ fontWeight: "bold", color: brandColors.primary }}>
            {data?.vendedor ?? "nós"}
          </span>
          .
        </p>
      </div>
    </>
  );
}
